export const glassCard = {
  bg: 'whiteAlpha.100',
  backdropFilter: 'blur(10px)',
  border: '1px solid',
  borderColor: 'whiteAlpha.200',
}

export const inputStyle = {
  color: 'white',
  borderColor: 'whiteAlpha.300',
  _placeholder: { color: 'whiteAlpha.400' },
  size: 'sm' as const,
}

export const labelStyle = {
  color: 'whiteAlpha.700',
  fontSize: 'xs' as const,
  fontWeight: 'semibold',
  textTransform: 'uppercase' as const,
  letterSpacing: 'wide',
}
